import { useState } from 'react'
import { Stack, Typography, useTheme } from '@mui/material'
import { useTranslation } from 'react-i18next'
import FSCardButton from '../common/atoms/CardButton'
import FsLegalMenu from './LegalMenu'
import FsGeneralMenu from './GeneralMenu'
import FsLeftInfoDrawer from '../common/atoms/LeftInfoDrawer'

const FSReportDrawer = ({
  isOpen,
  onClose,
  setGenerationStatus,
}: {
  isOpen: boolean
  onClose: any
  setGenerationStatus: (status: string) => void
}) => {
  const { t } = useTranslation()
  const [screenType, setScreenType] = useState<'start' | 'general' | 'legal'>('start')
  const theme = useTheme()

  return (
    <FsLeftInfoDrawer
      open={isOpen}
      onClose={() => {
        onClose(setScreenType('start'))
      }}
    >
      <Stack>
        <Stack>
          <Typography variant="h1" color={theme.palette.primary.main} mb={1}>
            {t('report.creation')}
          </Typography>
          <Typography variant="h2" className='mb-5 mt-2'>
            {t('report.type')}
          </Typography>
          <Stack
            sx={{
              gap: 3,
              mb: 6,
              display: 'flex',
              flexDirection: screenType === 'start' ? 'column' : 'row',
              transition: '0.5s all ease-in-out',
            }}
          >
            <FSCardButton
              header={screenType === 'start' ? t('general.reports') : t('general')}
              content={screenType === 'start' ? t('description.general') : ''}
              icon="generalreport"
              size={screenType === 'start' ? 'lg' : 'sm'}
              disabled={screenType === 'general'}
              onClick={() => {
                setScreenType('general')
              }}
            />
            <FSCardButton
              header={screenType === 'start' ? t('legal.reports') : t('legal')}
              content={screenType === 'start' ? t('description.legal') : ''}
              icon="legalreport"
              size={screenType === 'start' ? 'lg' : 'sm'}
              disabled={screenType === 'legal'}
              onClick={() => {
                setScreenType('legal')
              }}
            />
          </Stack>
          {screenType === 'legal' ? (
            <>
              <Typography variant="h2" mb={2}>
                {t('select.report.parameters')}
              </Typography>
              <FsLegalMenu onClose={onClose} setGenerationStatus={setGenerationStatus} />
            </>
          ) : screenType === 'general' ? (
            <>
              <Typography variant="h2" className='mb-3'>
                {t('select.report.parameters')}
              </Typography>
              <FsGeneralMenu onClose={onClose} setGenerationStatus={setGenerationStatus} />
            </>
          ) : null}
        </Stack>
      </Stack>
    </FsLeftInfoDrawer>
  )
}

export default FSReportDrawer
